const {gql} = require('graphql-tag')

export default gql`
  mutation removeFilmMasterPosterFrame ($id: ID!) {
    removeFilmMasterPosterFrame (id: $id) {
      artworkID
    }
  }
`
